import { stringSearch } from '@luminovo/design-system';
import { createFileRoute } from '@tanstack/react-router';

import QuoteRequestAssignPage from '@/areas/quote-requests/QuoteRequests/QuoteRequestAssignPage/QuoteRequestAssignPage';
import { sourcingViewModulePermissions } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/projects/$projectId/sourcing/quote-requests/assign')({
    staticData: {
        access: { permissions: ['view:sourcing'], modulePermissions: sourcingViewModulePermissions },
        chrome: 'none',
    } satisfies PageStaticData,
    validateSearch: stringSearch({ storageKey: 'optional' }),
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const { projectId } = Route.useParams();
    const storageKey = Route.useSearch({ select: (search) => search.storageKey });
    return <QuoteRequestAssignPage context={{ type: 'Rfq', id: projectId }} storageKey={storageKey} />;
}
